module.exports = __webpack_public_path__ + "static/img/Woman RTW.aec4b94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Woman RTW.jpg
// module id = O6QM
// module chunks = 1